<div class="{{ size }} d-inline-block">
  <div class="chip text-center rounded-pill" fxLayout="column"
    [ngStyle]="{'background-color': chip?.bgColor, 'justify-content': chip?.textAlign, 'color': chip?.color  }">
    <p class="mb-0 count" [ngStyle]="{'text-align': chip?.textAlign}"
      *ngIf="chip?.value || chip?.value === 0">{{ chip?.value }}</p>
    <span class="m-0 label" [ngStyle]="{'text-align': chip?.textAlign}">{{ chip?.title | translate}}</span>
  </div>
</div>
